// @ts-expect-error: implicitly has an 'any' type
import buildLocalizeFn from 'date-fns/locale/_lib/buildLocalizeFn/index';
import enUsLocale from 'date-fns/locale/en-US';

const monthValues = {
  narrow: ['E', 'P', 'M', 'A', 'M', 'H', 'H', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Ene', 'Peb', 'Mar', 'Abr', 'May', 'Hun', 'Hul', 'Ago', 'Set', 'Okt', 'Nob', 'Dis'],
  wide: [
    'Enero',
    'Pebrero',
    'Marso',
    'Abril',
    'Mayo',
    'Hunyo',
    'Hulyo',
    'Agosto',
    'Setyembre',
    'Oktubre',
    'Nobyembre',
    'Disyembre',
  ],
};

const shortDayValues = ['Lin', 'Lun', 'Mar', 'Miy', 'Huw', 'Biy', 'Sab'];
const dayValues = {
  narrow: ['Li', 'Lu', 'Ma', 'Mi', 'Hu', 'Bi', 'Sa'],
  short: shortDayValues,
  abbreviated: shortDayValues,
  wide: ['Linggo', 'Lunes', 'Martes', 'Miyerkules', 'Huwebes', 'Biyernes', 'Sabado'],
};

const defaultFormattingDayPeriodValues = {
  am: 'AM',
  pm: 'PM',
  midnight: 'ng hatinggabi',
  noon: 'ng tanghali',
  morning: 'ng umaga',
  afternoon: 'ng hapon',
  evening: 'ng gabi',
  night: 'ng gabi',
};
const formattingDayPeriodValues = {
  narrow: {
    ...defaultFormattingDayPeriodValues,
    am: 'A',
    pm: 'P',
  },
  abbreviated: defaultFormattingDayPeriodValues,
  wide: defaultFormattingDayPeriodValues,
};

const defaultDayPeriodValues = {
  am: 'AM',
  pm: 'PM',
  midnight: 'hatinggabi',
  noon: 'tanghali',
  morning: 'umaga',
  afternoon: 'hapon',
  evening: 'gabi',
  night: 'gabi',
};
const dayPeriodValues = {
  narrow: {
    ...defaultDayPeriodValues,
    am: 'A',
    pm: 'P',
  },
  abbreviated: defaultDayPeriodValues,
  wide: defaultDayPeriodValues,
};

function ordinalNumber(dirtyNumber: any): string {
  const number = Number(dirtyNumber);
  return `ika-${number}`;
}

export const localize: Locale['localize'] = {
  ordinalNumber,
  era: enUsLocale.localize!.era,
  quarter: enUsLocale.localize!.quarter,
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide',
  }),
};
